export default __webpack_public_path__ + "static/media/ios-en.9d2c30d4.gif";